import type { QuickstartT } from "@patient-watch/types";
import type { RoleT } from "@patient-watch/types";
import { createFileRoute } from "@tanstack/react-router";
import QrCodeInviteForm from "../../../features/qr-code/components/QrCodeInviteForm";
import type { OrganisationSummary } from "@patient-watch/types";
import type { UserMetadata } from "@patient-watch/types/zod/auth";

const OrganisationQuickstartQrCodePage = () => {
    const search = Route.useSearch();

    return <QrCodeInviteForm defaultRole={search.role} defaultOrganisationId={search.organisation?.organisation_id} />;
};

export const Route = createFileRoute("/_app/invite/qr-code")({
    component: OrganisationQuickstartQrCodePage,
    validateSearch: (search: Record<string, unknown>): UserMetadata => {
        return {
            role: (search?.role as RoleT) ?? undefined,
            email: (search?.email as string) ?? undefined,
            organisation: (search?.organisation as OrganisationSummary) ?? undefined,
            quickstart: (search?.quickstart as QuickstartT) ?? undefined,
        };
    },
});
